import { render, staticRenderFns } from "./BottomCustom.vue?vue&type=template&id=6e1ab692&scoped=true&"
import script from "./BottomCustom.vue?vue&type=script&lang=js&"
export * from "./BottomCustom.vue?vue&type=script&lang=js&"
import style0 from "./BottomCustom.vue?vue&type=style&index=0&id=6e1ab692&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ab692",
  null
  
)

export default component.exports